module.exports = __webpack_public_path__ + "img/bg-title.a2ea8ee8.png";